import { CityState, DataSource, Label, Layout, Location, Panel, Switch, Textbox } from "@mcleod/components";
import { StopNotesAndReferenceNumbers } from "../StopNotesAndReferenceNumbers";
import { StopShowAsButton } from "../StopShowAsButton";

export abstract class AutogenLayoutRecOrderStop extends Layout {
    citystate: CityState;
    labelAdditionalStopDetails: Label;
    labelCreatingLocation: Label;
    labelPickup: Label;
    layoutStopNotesAndRefNbrs: StopNotesAndReferenceNumbers;
    layoutStopShowAsButton: StopShowAsButton;
    panel1: Panel;
    panelAdditionalDetails: Panel;
    panelMain: Panel;
    panelStopCommentsReferenceNumbers: Panel;
    panelStopFreeForm: Panel;
    sourceStopRecOrder: DataSource;
    switchApptRequired: Switch;
    switchPalletsRequired: Switch;
    switchPickupConsignee: Switch;
    textboxAddress2: Textbox;
    textboxAddress: Textbox;
    textboxAppointmentStatusId: Textbox;
    textboxCases: Textbox;
    textboxContactEmail: Textbox;
    textboxContactName: Textbox;
    textboxDriverLoadUnload: Textbox;
    textboxLocationCode: Textbox;
    textboxLocationId: Location;
    textboxLocationName: Textbox;
    textboxPalletsHowMany: Textbox;
    textboxPhone: Textbox;
    textboxVolume: Textbox;
    textboxWeight: Textbox;
    textboxZoneId: Textbox;
}
